import { html, TemplateResult } from 'lit';
import { BookingRequest, Dispatcher } from '../../types/booking-request';
import { showStepWhenCurrentIs, stepId, STEP_PERSONAL_DETAILS, STEP_SUMMARY } from '../../types/steps';
import { WPContent, WPHousePosts } from '../../types/wp-data';
import { stepIntro } from './partials/step-intro';
import { reservationSummary } from './partials/reservation-summary';
import { checkIfBookingDataIsValid } from '../../types/booking-data';
import { staticText } from '../../static-text';

export function stepSummary(
	state: BookingRequest,
	dispatch: Dispatcher,
	content: WPContent,
	posts: WPHousePosts
): TemplateResult {
	if ( !( showStepWhenCurrentIs( STEP_SUMMARY, state.currentStep ) ) ) {
		return html``;
	}

	if ( !checkIfBookingDataIsValid( state.bookingData.weekData ) ) {
		return html``;
	}

	const goToNextStepHandler = () => {
		dispatch( {
			type: 'UPDATE_CURRENT_STEP',
			currentStep: STEP_PERSONAL_DETAILS,
		} );
	};

	return html`
		<div class="step" id="${stepId( STEP_SUMMARY )}">
			<div class="section theme-white">
				<div class="wrapper">
					<div class="double-columns">
						<div class="double-columns__column">
							${stepIntro( content.titleSummary, content.textSummary )}

							<button
								@click=${goToNextStepHandler}
								class="button"
							>
								${staticText.personalDetailsForm}
							</button>
						</div>

						<div class="double-columns__column">
							${reservationSummary( state, posts )}
						</div>
					</div>
				</div>
			</div>
		</div>
	`;
}
